export { SplashComponent } from './splash.component';
export { SplashModule } from "./splash.module";
